function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.1 1.1c-.1-.1-.2-.1-.4-.1s-.4.1-.5.2c-.2.2-.3.6-.1.9 1 1.9 1.5 4 1.5 6.2 0 7.3-6 13.3-13.3 13.3-2.2 0-4.3-.5-6.2-1.5-.1-.1-.2-.1-.3-.1-.2 0-.4.1-.5.2-.3.2-.3.6-.2.9C3.7 26 8.7 29 14.2 29 22.4 29 29 22.4 29 14.2c0-5.5-3-10.5-7.9-13.1zm-6.9 26.3c-3.7 0-7.4-1.6-9.9-4.4l-.5-.6.8.2c1.2.3 2.5.5 3.8.5 8.2 0 14.8-6.6 14.8-14.8 0-1.3-.2-2.5-.5-3.7l-.2-.8.6.5c2.8 2.5 4.4 6.1 4.4 9.9-.1 7.3-6 13.2-13.3 13.2zM1.6 7.8c-.3-.3-.3-.7 0-1l5.7-5.6c.3-.3.7-.3 1 0L14 6.8c.3.3.3.7 0 1-.1.2-.3.2-.4.2-.2 0-.4-.1-.5-.2L8.6 3.4v12.2c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7V3.4L2.6 7.8c-.2.3-.7.3-1 0z"
})));